export default __webpack_public_path__ + "static/media/patient-interactive-video-small.40958a8a.jpg";